// extracted by mini-css-extract-plugin
module.exports = {"Confirm":"_1_E4m","modalBox":"_2iY0i","InputError":"_3OpW-","Label":"_1gBbz","Label_text":"_2R_Jv","Error":"_3Tlvy"};